import { Injectable } from '@angular/core';
import { Subscription, BehaviorSubject, throwError, Observable } from 'rxjs';

import { SystemSettingInterface } from '../../../system-setting/interfaces';
import { EnvironmentUtilService } from '../util/environment-util.service';

import { ApiService } from './api.service';

@Injectable({
  providedIn: 'root',
})
export class SystemSettingApiService {
  private readonly _loading = new BehaviorSubject<boolean>(<boolean>false);
  private readonly _settings = new BehaviorSubject<SystemSettingInterface[]>([]);
  private readonly _inventorySettings = new BehaviorSubject<SystemSettingInterface>(
    <SystemSettingInterface>{},
  );
  private readonly _currentSetting =
    new BehaviorSubject<SystemSettingInterface | null>(null);

  loading$ = this._loading.asObservable();
  settings$ = this._settings.asObservable();
  inventorySettings$ = this._inventorySettings.asObservable();
  currentSetting$ = this._currentSetting.asObservable();
  environment = this.environmentUtilService.getEnvironment();

  constructor(
    private apiService :ApiService,
    private environmentUtilService :EnvironmentUtilService,
  ) {}

  getSetting() :Subscription {
    this._loading.next(true);

    return this.apiService.get(`${this.environment.urlV1}/settings`).subscribe({
      next: (response :any) => {
        this._loading.next(false);
        this._settings.next(response);
      },
      error: (error) => throwError(() => new Error(error)),
    });
  }

  getInventorySettings() :Subscription {
    this._loading.next(true);

    return this.apiService
      .get(`${this.environment.urlV1}/settings/inventory`)
      .subscribe({
        next: (response :any) => {
          this._loading.next(false);
          this._inventorySettings.next(response);
        },
        error: (error) => throwError(() => new Error(error)),
      });
  }

  getSettingsByKey(key :string) :Observable<any> {
    return this.apiService.get(`${this.environment.urlV1}/settings/keyvalue`, {
      params: { key },
    });
  }

  setCurrentSettingKey(key :string) :void {
    const currentSetting =
      this._settings.value.find((setting) => setting.key === key) || null;
    this._currentSetting.next(currentSetting);
  }

  getSalesPurgatorySettings() :Observable<any> {
    return this.apiService.get(
      `${this.environment.urlV1}/settings/sales_purgatory`,
    );
  }

  getInventorySettingsAsyc() :Observable<any> {
    return this.apiService.get(`${this.environment.urlV1}/settings/inventory`);
  }

  getInvoiceSettings() :Observable<any> {
    return this.apiService.get(`${this.environment.urlV1}/settings/invoice`);
  }

  getSmartFulfillmentPriorityListSettings() :Observable<any> {
    return this.apiService.get(
      `${this.environment.urlV1}/settings/smart-fulfillment-priority-list`,
    );
  }

  saveSmartFulfillmentPriorityListSettings(payload :{
    default_fulfillment_priority_list_id :number;
  }) :Observable<any> {
    return this.apiService.post({
      path: `${this.environment.urlV1}/settings/smart-fulfillment-priority-list`,
      body: payload,
    });
  }
}
